import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getLotesImpresionFiltered } from 'services/reportes'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_LOTES_IMPRESION_FILTERED(action) {
  try {
    const ladronesData = yield call(getLotesImpresionFiltered, action.payload)
    if (ladronesData.ok) {
      yield put({
        type: actions.LOTES_IMPRESION_LOAD_SUCCEEDED,
        payload: ladronesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Lotes de impresión')
      yield put({
        type: actions.LOTES_IMPRESION_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.LOTES_IMPRESION_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOTES_IMPRESION_LOAD_REQUESTED, GET_LOTES_IMPRESION_FILTERED)])
}
